module.exports = __webpack_public_path__ + "img/AICOrgChart.14d92fc1.png";